import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { OriginsService } from '../origins.service';

@Component({
  selector: 'app-origins-detail',
  templateUrl: './origins-detail.component.html',
  styleUrls: ['./origins-detail.component.scss']
})
export class OriginsDetailComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public origin: any = {};
  constructor(
    private originsService: OriginsService,

    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.loadData(this.config.data.id);
  }
  loadData(id) {
    if (id) {
      this.originsService.get(id).subscribe(
        data => {
          this.origin = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.origin.id === "undefined") {
      this.originsService.add(this.origin).subscribe(
        data => {
          this.origin = data;
          this.dynamicDialogRef.close(this.origin);
          this.messageService.add({ closable: false, severity: 'success', summary: "Origen añadido correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.originsService.save(this.origin.id, this.origin).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Origen guardado correctamente" });
          this.dynamicDialogRef.close(this.origin);
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el origin " + this.origin.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.originsService.delete(this.origin.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  onEvent(event) {
    if (event.component == "origins.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.save(event);
    }
  }
}
